import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserAuthGuard } from 'src/app/guards/user-auth.guard';
import { MainAppPageLayoutComponent } from './layouts/main-app-page-layout/main-app-page-layout.component';
import { MainAppComponent } from './main-app.component';
import { MainAppAdminForumComponent } from './pages/main-app-admin/main-app-admin-pages/main-app-admin-forum/main-app-admin-forum.component';
import { MainAppAdminForumCreateEditComponent } from './pages/main-app-admin/main-app-admin-pages/main-app-admin-forum/pages/main-app-admin-forum-create-edit/main-app-admin-forum-create-edit.component';
import { MainAppAdminUserManagementComponent } from './pages/main-app-admin/main-app-admin-pages/main-app-admin-user-management/main-app-admin-user-management.component';
import { MainAppBillingComponent } from './pages/main-app-billing/main-app-billing.component';
import { MainAppHomeComponent } from './pages/main-app-home/main-app-home.component';
import { MainAppNotificationComponent } from './pages/main-app-notification/main-app-notification.component';
import { MainAppReportMasterComponent } from './pages/main-app-report/main-app-report-pages/main-app-report-master/main-app-report-master.component';
import { MainAppReportComponent } from './pages/main-app-report/main-app-report.component';
import { MainAppSocialDetailComponent } from './pages/main-app-social/pages/main-app-social-detail/main-app-social-detail.component';
import { MainAppSocialManagementListComponent } from './pages/main-app-social/pages/management-pages/main-app-social-management-list/main-app-social-management-list.component';
import { MainAppMyWallsComponent } from './pages/main-app-my-walls/main-app-my-walls.component';
import { MainAppDashboardHomeComponent } from './pages/main-app-dashboard-home/main-app-dashboard-home.component';

export const MAINAPPROUTE = {
  dashboardHome: 'dashboard-home',
  dashboard: 'dashboard',
  assetHub: 'asset-hub',
  lba: 'lba',
  admin: 'admin',
  walls: 'walls',
  sentimentAnalysis: "sentiment-analysis",
  event: 'program',
  user: 'user',
  myEvent: 'my-event'
}

const routes: Routes = [
  {
    path: '',
    component: MainAppComponent,
    // canActivateChild: [UserAuthGuard],
    children: [
      // {
      //   path: '',
      //   //component: MainAppHomeComponent,
      //   redirectTo: MAINAPPROUTE.dashboard,
      //   pathMatch: "full"
      // },
      {
        path: 'containder',
        loadChildren: () => import('src/app/views/pages/main-app/pages/containder/containder.module').then(m => m.ContainderModule),
      },
      {
        path: "",
        // loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-dashboard/main-app-dashboard.module').then(m => m.MainAppDashboardModule),
        loadChildren: () => import('src/app/modules/crm/crm.module').then(m => m.CRMModule),
      },
      {
        path: 'content',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-content/main-app-content.module').then(m => m.MainAppContentModule),
      },
      {
        path: MAINAPPROUTE.lba,
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-lba-blast/main-app-lba-blast.module').then(m => m.MainAppLbaBlastModule),
      },
      {
        path: MAINAPPROUTE.assetHub,
        loadChildren: () => import('src/app/views/pages/main-app/pages/my-product-and-service/my-product-and-service.module').then(m => m.MyProductAndServiceModule),
      },
      {
        path: 'public-wifi',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-public-wifi/main-app-public-wifi.module').then(m => m.MainAppPublicWifiModule),
      },
      {
        path: 'services',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-services/main-app-services.module').then(m => m.MainAppServicesModule),
      },
      {
        path: 'social',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-services/main-app-services.module').then(m => m.MainAppServicesModule),
        //loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-social/main-app-social.module').then(m => m.MainAppSocialModule),
      },
      {
        path: 'theonometer',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-theonometer/main-app-theonometer.module').then(m => m.MainAppTheonometerModule),
      },
      {
        path: 'user',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-user/main-app-user.module').then(m => m.MainAppUserModule),
      },
      {
        path: 'product',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-product/main-app-product.module').then(m => m.MainAppProductModule),
      },
      {
        path: 'referral',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-referral/main-app-referral.module').then(m => m.MainAppReferralModule),
      },
      {
        path: 'media',
        loadChildren: () => import('src/app/modules/media-player/media-player.module').then(m => m.MediaPlayerModule),
      },
      {
        path: 'dynamic-form-test',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-dynamic-form-test/main-app-dynamic-form-test.module').then(m => m.MainAppDynamicFormTestModule),
      },
/*       {
        path: '',
        component: MainAppPageLayoutComponent,
        children: [
          {
            path: 'forum',
            loadChildren: () => import('src/app/modules/forum/forum.module').then(m => m.ForumModule),
          },
          {
            path: 'blog',
            loadChildren: () => import('src/app/modules/blog/blog.module').then(m => m.BlogModule),
          },
          {
            path: MAINAPPROUTE.event,
            loadChildren: () => import('src/app/modules/event/event.module').then(m => m.EventModule),
            data: {
              app: true,
            }
          },
          {
            path: 'program',
            loadChildren: () => import('src/app/modules/program/program.module').then(m => m.ProgramModule),
          },
          {
            path: 'disbursement',
            loadChildren: () => import('src/app/modules/disbursement/disbursement.module').then(m => m.DisbursementModule),
          },
        ]
      }, */
      // {
      //   path: 'report',
      //   component: MainAppReportComponent,
      // },
      // {
      //   path: 'report/:id',
      //   component: MainAppReportMasterComponent,
      // },
    /*   {
        path: 'billing',
        component: MainAppBillingComponent,
      },
      {
        path: 'notification',
        component: MainAppNotificationComponent,
      }, */
      {
        path: MAINAPPROUTE.walls,
        component: MainAppMyWallsComponent,
      },
      {
        path: MAINAPPROUTE.sentimentAnalysis,
        loadChildren: () => import('src/app/modules/social-crawler/social-crawler.module').then(m => m.SocialCrawlerModule),
      },
      {
        path: 'my-program',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-my-program/main-app-my-program.module').then(m => m.MainAppMyProgramModule),
      },
      {
        path: MAINAPPROUTE.myEvent,
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-my-event/main-app-my-event.module').then(m => m.MainAppMyEventModule),
      },
      {
        path: 'my-blog',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-my-blog/main-app-my-blog.module').then(m => m.MainAppMyBlogModule),
      },
      {
        path: '',
        loadChildren: () => import('src/app/views/pages/main-app/pages/main-app-admin/main-app-admin.module').then(m => m.MainAppAdminModule),
      },
      {
        path: 'dashboard-home',
        component: MainAppDashboardHomeComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainAppRoutingModule { }
